
import React, { Component, useEffect, useState } from 'react'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/lab/Alert';
import Alert from '@mui/lab/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import styles from './MyMaterialUi.module.css';
import {Close, Close as CloseIcon} from "../Svgs";



function Alertt(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export class index extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}






export function ResponseAlert(props) {

	return (
		props.open ?
			<div className={styles.responseAlerts}>
				<Collapse in={props.errorStatus}>
					<Alert severity="error"
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								size="small"
								onClick={props.close}
							>
								<CloseIcon />
							</IconButton>
						}
					>
						{props.errors.map((msg, index) => (<span key={index}>{msg}</span>))}
					</Alert>
				</Collapse>
				<Collapse in={props.successStatus}>
					<Alert severity="success"
						action={
							<IconButton
								aria-label="close"
								color="inherit"
								size="small"
								onClick={props.close}
							>
								<CloseIcon />
							</IconButton>
						}
					>
						{props.success.map((msg, index) => (<span key={index}>{msg}</span>))}
					</Alert>
				</Collapse>
			</div> :
			null
	)
}
















export function SnackNotifications(props) {

	return (
		props.open && props.errors ?
			<div>
				<Snackbar open={props.errorStatus} onClose={props.close}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
					<Alert onClose={props.close} variant="filled" severity="error">
						{
							props.errors.map((error, index) => (
								<span key={index}>{error}</span>
							))
						}
					</Alert>
				</Snackbar>


				<Snackbar open={props.successStatus} onClose={props.close}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
					<Alert onClose={props.close} variant="filled" severity="success">
						{
							props.success.map((error, index) => (
								<span key={index}>{error}</span>
							))
						}
					</Alert>
				</Snackbar>

			</div> :
			null
	)
}

export default index
